import react, { useEffect, useState, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';

type QuillEditorProps = {
  htmlContent: string;
  setHtmlContent: (htmlContent: string) => void;
}

function useQuery() {
    return new URLSearchParams(useLocation().search);
}


const Editpost = ({ htmlContent, setHtmlContent }: QuillEditorProps) => {

    useEffect(() => {
  const isLoggedIn = sessionStorage.getItem('loggedIn') === 'true';
  if (!isLoggedIn) {
    window.location.href = '/login';
  }
}, []);


    const modules = useMemo(
            () => ({
                toolbar: { // 툴바에 넣을 기능
                    container: [
                        ["bold", "italic", "underline", "strike", "blockquote"],
                        [{ size: ["small", false, "large", "huge"] }, { color: [] }],
                        [
                            { list: "ordered" },
                            { list: "bullet" },
                            { indent: "-1" },
                            { indent: "+1" },
                            { align: [] },
                        ],
                    ],
                },
            }), []);


    const query = useQuery();
    const notice_no = query.get('notice_no');

    const [title, setTitle] = useState('');
    const [content, setContent] = useState('');


    useEffect(() => {
    if (notice_no) {
      fetch(`/api/get-post?notice_no=${notice_no}`)
        .then((res) => res.json())
        .then((data) => {
          setTitle(data.notice_title);
          setContent(data.notice_desc || '');
        });
    }
  }, [notice_no]);


  return (
    <div>
        <div className='title-box'>
                  <h1 className='maintitle'>게시글 수정</h1>
                </div>
              <form method="POST" action="/api/update-post">
                <input type='hidden' name='notice_no' value={notice_no || ''} />
                <div className='post-title'>
                    <textarea
                    name='post_title'
                    value={title}
                    rows={1}
                    onChange={(e) => setTitle(e.target.value)}
                    cols={50}
                    placeholder="여기에 제목을 입력하세요."
                    className='post-content-title'
                    />
                </div>
                <div className='editor' id='editor'>
                <ReactQuill value={content} onChange={setContent} modules={modules} />
                </div>
                <input type="hidden" name="post_content" value={content} />
                <div className='post-send-box'>
                <button className='del' id='del'>취소</button>
                <button className='submit' type='submit'>저장</button>
                </div>
                </form>
                <footer className='writer-ver'>
                  Version 0.4 β
                </footer>
    </div>
  )
            
    
    
}

export default Editpost;